import {createSlice} from "@reduxjs/toolkit";
import {getCalendar} from "../../../utils/date";
export * from "./salesUpdateSlice";

const initialState = {
	// 공통 검색 및 기타 정보
	searchPartner : 0,				// 가맹정 고유번호
	searchBranch : 0,				// 지점 고유번호
	searchDate : undefined,			// 검색 날짜
	searchPeriodType : "daily",		// 검색 기간 타입
	pageScroll : 0,					// 메뉴 스크롤 정보
	detailPageScroll : 0,			// 상세 스크롤 정보
	detailBranchPageScroll : 0,		// 전 지점 상세 스크롤 정보

	// [홈] 매출 개요 정보
	summaryInfo : {
		searchPartner : 0,
		searchBranch : 0,
		searchDate : "",
		searchPeriodType : "",
		data : undefined,
		isLoading : false,
		isError : false,
		timestamp : undefined
	},

	// [홈] 이용권 종류별 매출 요약 정보
	summaryVoucherInfo : {
		searchPartner : 0,
		searchBranch : 0,
		searchDate : "",
		searchPeriodType : "",
		data : undefined,
		isLoading : false,
		isError : false,
		timestamp : undefined
	},

	// [홈] 미수금 요약 정보
	summaryReceivableInfo : {
		searchPartner : 0,
		searchBranch : 0,
		searchDate : "",
		receivableAmount : 0,
		isLoading : false,
		isError : false,
		timestamp : undefined
	},

	// [상세] 매출 개요 정보
	detailSummaryInfo : {
		searchPartner : 0,
		searchBranch : 0,
		searchDate : "",
		searchPeriodType : "",
		searchFilter : "",
		data : undefined,
		isLoading : false,
		isError : false,
		timestamp : undefined
	},

	// [상세] 전 지점 매출 개요 정보
	branchSummaryInfo : {
		searchPartner : 0,
		searchBranch : 0,
		searchDate : "",
		searchPeriodType : "",
		searchFilter : "",
		data : undefined,
		isLoading : false,
		isError : false,
		timestamp : undefined
	},

	// [상세] 주문 결제 내역 정보
	orderPaymentInfo : {
		data : undefined,
		page : 1,
		pageSize : 10,
		pageState : false,
		lastSeqOrderPayment : 0,
		lastSeqRefundInfo : 0,
		timestamp : undefined
	},

	// [상세] 전 지점 매출 요약 정보
	branchPeriodInfo : {
		data : undefined,
		page : 1,
		pageSize : 10,
		pageState : false,
		timestamp : undefined
	},

	// [상세] 주문 내역 정보
	orderInfo : {
		data : undefined,
		page : 1,
		pageSize : 10,
		pageState : false,
		timestamp : undefined
	},

	// [상세] 이용권 종류별 매출
	voucherInfo : {
		searchPartner : 0,
		searchBranch : 0,
		searchDate : "",
		searchPeriodType : "",
		searchFilter : "",
		data : undefined,
		dataList : undefined,
		page : 1,
		pageSize : 10,
		pageState : false,
		isLoading : false,
		isError : false,
		timestamp : undefined
	},

	// [상세] 전 지점 이용권 종류별 매출
	branchVoucherInfo : {
		searchPartner : 0,
		searchDate : "",
		searchPeriodType : "",
		searchFilter : "",
		data : undefined,
		dataList : undefined,
		page : 1,
		pageSize : 10,
		pageState : false,
		isLoading : false,
		isError : false,
		timestamp : undefined
	},

	// [상세] 누적 미수금 개요 및 목록
	receivableInfo : {
		searchPartner : 0,
		searchBranch : 0,
		searchDate : "",
		data : undefined,
		dataList : undefined,
		page : 1,
		pageSize : 10,
		pageState : false,
		isLoading : false,
		isError : false,
		timestamp : undefined
	},

	// [상세] 전 지점 누적 미수금 개요 및 목록
	branchReceivableInfo : {
		searchPartner : 0,
		searchBranch : 0,
		searchDate : "",
		data : undefined,
		dataList : undefined,
		page : 1,
		pageSize : 10,
		pageState : false,
		isLoading : false,
		isError : false,
		timestamp : undefined
	}
};

const sales = createSlice({
	name : "sales",
	initialState,
	reducers : {
		fetchSearchInfo : (state, action) => {
			state = Object.assign(state, action.payload);
		},
		fetchPageScroll : (state, action) => {
			state.pageScroll = action.payload;
		},
		fetchSearchDate : (state, action) => {
			state.searchDate = state.voucherInfo.searchDate = state.branchVoucherInfo.searchDate =
				state.detailSummaryInfo.searchDate = state.branchSummaryInfo.searchDate = action.payload;
		},
		fetchSearchPeriodType : (state, action) => {
			state.searchPeriodType = state.voucherInfo.searchPeriodType = state.branchVoucherInfo.searchPeriodType =
				state.detailSummaryInfo.searchPeriodType = state.branchSummaryInfo.searchPeriodType = action.payload;
		},
		fetchSearchFilter : (state, action) => {
			for(let name in state) {
				if(typeof state[name] == "object") {
					if(state[name].searchFilter) {
						state[name].searchFilter = "";
					}
				}
			}
		},
		fetchSearchPartnerAndBranch : (state, action) => {
			const {searchPartner, searchBranch} = action.payload || {};
			state.searchPartner = searchPartner;
			state.searchBranch = searchBranch;
			for(let name in state) {
				if(typeof state[name] == "object") {
					if(state[name].searchPartner) {
						state[name].searchPartner = state[name].searchBranch = 0;
					}
				}
			}
		},
		fetchSummaryInfo : (state, action) => {
			state.summaryInfo = Object.assign(state.summaryInfo, action.payload);
		},
		fetchDetailSummaryInfo :  (state, action) => {
			state.detailSummaryInfo = Object.assign(state.detailSummaryInfo, action.payload);
		},
		fetchOrderPaymentInfo :  (state, action) => {
			state.orderPaymentInfo = Object.assign(state.orderPaymentInfo, action.payload);
		},
		fetchOrderPaymentInfoList : (state, action) => {
			const {paymentList, lastSeqOrderPayment, lastSeqRefundInfo} = action.payload;
			state.orderPaymentInfo.data.paymentList = state.orderPaymentInfo.data.paymentList.concat(paymentList);
			state.orderPaymentInfo.page = state.orderPaymentInfo.page + 1;
			state.orderPaymentInfo.pageState = (paymentList.length == state.orderPaymentInfo.pageSize);
			if(state.orderPaymentInfo.page == 2) {
				state.orderPaymentInfo.lastSeqOrderPayment = lastSeqOrderPayment;
				state.orderPaymentInfo.lastSeqRefundInfo = lastSeqRefundInfo;

			}
		},
		fetchBranchPeriodInfo :  (state, action) => {
			state.branchPeriodInfo = Object.assign(state.branchPeriodInfo, action.payload);
		},
		fetchBranchPeriodInfoList : (state, action) => {
			state.branchPeriodInfo.data.overviewList = state.branchPeriodInfo.data.overviewList.concat(action.payload);
			state.branchPeriodInfo.page = state.branchPeriodInfo.page + 1;
			state.branchPeriodInfo.pageState = (action.payload.length == state.branchPeriodInfo.pageSize);
		},
		fetchBranchSummaryInfo :  (state, action) => {
			state.branchSummaryInfo = Object.assign(state.branchSummaryInfo, action.payload);
		},
		fetchSummaryVoucherInfo : (state, action) => {
			state.summaryVoucherInfo = Object.assign(state.summaryVoucherInfo, action.payload);
		},
		fetchVoucherInfo : (state, action) => {
			state.voucherInfo = Object.assign(state.voucherInfo, action.payload);
		},
		fetchVoucherInfoList : (state, action) => {
			const {paymentList, lastSeqOrderPayment, lastSeqRefundInfo} = action.payload;
			state.voucherInfo.dataList.paymentList = state.voucherInfo.dataList.paymentList.concat(paymentList);
			state.voucherInfo.page = state.voucherInfo.page + 1;
			state.voucherInfo.pageState = (paymentList.length == state.voucherInfo.pageSize);
			if(state.voucherInfo.page == 2) {
				state.voucherInfo.dataList.lastSeqOrderPayment = lastSeqOrderPayment;
				state.voucherInfo.dataList.lastSeqRefundInfo = lastSeqRefundInfo;
			}
		},
		fetchBranchVoucherInfo : (state, action) => {
			state.branchVoucherInfo = Object.assign(state.branchVoucherInfo, action.payload);
		},
		fetchBranchVoucherInfoList : (state, action) => {
			state.branchVoucherInfo.dataList = state.branchVoucherInfo.dataList.concat(action.payload);
			state.branchVoucherInfo.page = state.branchVoucherInfo.page + 1;
			state.branchVoucherInfo.pageState = (action.payload.length == state.branchVoucherInfo.pageSize);
		},
		fetchReceivableInfo : (state, action) => {
			state.receivableInfo = Object.assign(state.receivableInfo, action.payload);
		},
		fetchReceivableInfoList : (state, action) => {
			state.receivableInfo.dataList = state.receivableInfo.dataList.concat(action.payload);
			state.receivableInfo.page = state.receivableInfo.page + 1;
			state.receivableInfo.pageState = (action.payload.length == state.receivableInfo.pageSize);
		},
		fetchBranchReceivableInfo : (state, action) => {
			state.branchReceivableInfo = Object.assign(state.branchReceivableInfo, action.payload);
		},
		fetchBranchReceivableInfoList : (state, action) => {
			state.branchReceivableInfo.dataList = state.branchReceivableInfo.dataList.concat(action.payload);
			state.branchReceivableInfo.page = state.branchReceivableInfo.page + 1;
			state.branchReceivableInfo.pageState = (action.payload.length == state.branchReceivableInfo.pageSize);
		},
		fetchSummaryReceivableInfo : (state, action) => {
			state.summaryReceivableInfo = Object.assign(state.summaryReceivableInfo, action.payload);
		},
		fetchReset : (state, action) => {
			// , action.payload
			state = Object.assign(state, initialState);
		},
		fetchPageScroll : (state, action) => {
			const container = document.querySelector("#root #content");
			if(container) {
				if(action.payload == "restore") {
					container.scrollTop = state.pageScroll;
					state.pageScroll = 0;
				} else {
					state.pageScroll = container.scrollTop;
					state.detailPageScroll = state.detailBranchPageScroll = 0;
				}
			}
		},
		fetchDetailPageScroll : (state, action) => {
			const container = document.querySelector("#root #content");
			if(container) {
				if(action.payload == "restore") {
					container.scrollTop = state.detailPageScroll;
					state.detailPageScroll = 0;
				} else {
					state.detailPageScroll = container.scrollTop;
				}
			}
		},
		fetchDetailBranchPageScroll : (state, action) => {
			const container = document.querySelector("#root #content");
			if(container) {
				if(action.payload == "restore") {
					container.scrollTop = state.detailBranchPageScroll;
					state.detailBranchPageScroll = 0;
				} else {
					state.detailBranchPageScroll = container.scrollTop;
				}
			}
		}
	}
});

export const {
	fetchSearchInfo,
	fetchPageScroll,
	fetchDetailPageScroll,
	fetchDetailBranchPageScroll,
	fetchReset,
	fetchSearchDate,
	fetchSearchFilter,
	fetchSearchPeriodType,
	fetchSearchPartnerAndBranch,
	fetchVoucherInfo,
	fetchVoucherInfoList,
	fetchBranchVoucherInfo,
	fetchBranchVoucherInfoList,
	fetchSummaryVoucherInfo,
	fetchSummaryInfo,
	fetchReceivableInfo,
	fetchReceivableInfoList,
	fetchSummaryReceivableInfo,
	fetchDetailSummaryInfo,
	fetchBranchSummaryInfo,
	fetchBranchReceivableInfo,
	fetchBranchReceivableInfoList,
	fetchOrderPaymentInfo,
	fetchOrderPaymentInfoList,
	fetchBranchPeriodInfo,
	fetchBranchPeriodInfoList,
} = sales.actions;

export default sales.reducer;